import React, { useEffect, useRef } from 'react';
import { projects } from '../../projects';
import Project from './Project';
import './ProjectsList.css';

function ProjectsList() {
    const comingSoonRef = useRef(null)
    const dotsRef = useRef(null)

    useEffect(() => {
        // Initialize IntersectionObserver to animate on scroll
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show')
                }
            })
        })

        // Observe elements that should be animated
        if (comingSoonRef.current) observer.observe(comingSoonRef.current)
        if (dotsRef.current) observer.observe(dotsRef.current)
    }, [])

    const comingSoonStyles = {
        transform: projects.length % 2 === 0 ? "translateX(100%)" : "translateX(-100%)"
    }

    return (
        <div className="projects-container" id="projects">
            <h2 id="projects-heading">Some of my Projects</h2>
            {
                projects.map((project, i) => {
                    return <Project name={project.name} description={project.description} date={project.date} mainColor={project.mainColor} buttonBackgroundColor={project.buttonBackgroundColor} buttonTextColor={project.buttonTextColor} backgroundImage={project.backgroundImage} githubLink={project.githubLink} websiteLink={project.websiteLink} buttonText={project.buttonText} key={i}></Project>
                })
            }

            <div id="dots" ref={dotsRef}></div>

            <div className="comingsoon" style={comingSoonStyles} ref={comingSoonRef}>
                <div className="inner-comingsoon">
                    <h2>More projects are coming soon</h2>
                    <p>I'm always working on various projects, so more are on the way.</p>
                </div>
            </div>
        </div>
    );
}

export default ProjectsList;